import { FC, ReactNode } from 'react';
import { Heading } from '@chakra-ui/layout';

type CustomHeadingProps = {
  children: ReactNode;
  className?: string;
  fontSize?: number | string;
  textAlign?: 'center' | 'left' | 'right';
};

const CustomHeading: FC<CustomHeadingProps> = ({
  children,
  className,
  fontSize,
  textAlign,
}) => {
  return (
    <Heading
      // Section headings sit on the bare page ground: brand.active clears
      // 4.5:1 there in every combination (rule 7). Dark is the old blue.100;
      // light #2a4365 (was blue.900 #1a365d).
      color="brand.active"
      className={className}
      fontSize={fontSize}
      textAlign={textAlign}
    >
      {children}
    </Heading>
  );
};

export default CustomHeading;
